export const WING_KEYFRAMES = [0, -55, -5, -50, 0, -40, 0];
export const WING_TIMES = [0, 0.12, 0.28, 0.4, 0.58, 0.75, 1];
export const BODY_KEYFRAMES = [0, -1, -0.2, -0.6, 0];
export const BODY_TIMES = [0, 0.2, 0.5, 0.75, 1];
export const FLUTTER_DURATION = 1.0;
export const LOGO_EASE = [0.215, 0.61, 0.355, 1] as const;
export const FINE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';
